import { PlanetVideoJs } from '../adapters';

export abstract class VideoJsXr {
    abstract player: PlanetVideoJs;

    abstract dispose(): void;
}
